
// src/actions/google-api.js

import moment from 'moment'
import config from '../config'
import { emitAlertMessage, clearAlertMessage } from './alert-message'

export const FETCH_GOOGLE_DRIVE_FILE = "FETCH_GOOGLE_DRIVE_FILE"
export const FETCH_GOOGLE_DRIVE_FILE_REQUESTED = "FETCH_GOOGLE_DRIVE_FILE_REQUESTED"
export const FETCH_GOOGLE_DRIVE_FILE_COMPLETED = "FETCH_GOOGLE_DRIVE_FILE_COMPLETED"
export const FETCH_GOOGLE_DRIVE_FILE_FAILED = "FETCH_GOOGLE_DRIVE_FILE_FAILED"

export function fetchGoogleDriveFileRequested(url, componentId) {
  return {
    type: FETCH_GOOGLE_DRIVE_FILE_REQUESTED,
    url, componentId
  }
}

export function fetchGoogleDriveFile(url, componentId) {
  return function(dispatch) {
    const file_id = url.replace(/^https:\/\/[a-z]+\.google\.com\/[a-z]+\/[a-z]+\/([-_0-9a-zA-Z]+).*$/, '$1')
    dispatch(fetchGoogleDriveFileRequested(url, componentId))
    const gapi = global.gapi
    return gapi.client.drive.files.get({ fileId: file_id })
      .then((results)=> {
        dispatch(fetchGoogleDriveFileCompleted(url, results, componentId))
      })
      .catch((error)=> {
        dispatch(fetchGoogleDriveFileFailed(error, url, componentId))
      })
  }
}

export function fetchGoogleDriveFileCompleted(url, results, componentId) {
  return {
    type: FETCH_GOOGLE_DRIVE_FILE_COMPLETED,
    results: {
      title: results.result.name,
      url: url,
      mime_type: results.result.mimeType,
    },
    url, componentId
  }
}

export function fetchGoogleDriveFileFailed(error, url, componentId) {
  return {
    type: FETCH_GOOGLE_DRIVE_FILE_FAILED,
    error, url, componentId
  }
}

export const FETCH_GOOGLE_DRIVE_FOLDERS = "FETCH_GOOGLE_DRIVE_FOLDERS"
export const FETCH_GOOGLE_DRIVE_FOLDERS_REQUESTED = "FETCH_GOOGLE_DRIVE_FOLDERS_REQUESTED"
export const FETCH_GOOGLE_DRIVE_FOLDERS_COMPLETED = "FETCH_GOOGLE_DRIVE_FOLDERS_COMPLETED"
export const FETCH_GOOGLE_DRIVE_FOLDERS_FAILED = "FETCH_GOOGLE_DRIVE_FOLDERS_FAILED"

export function fetchGoogleDriveFoldersRequested() {
  return {
    type: FETCH_GOOGLE_DRIVE_FOLDERS_REQUESTED
  }
}

export function fetchGoogleDriveFolders() {
  return function(dispatch) {
    dispatch(fetchGoogleDriveFoldersRequested())

    // Get folder list from Google Drive
    const gapi = global.gapi
    return gapi.client.drive.files.list({
      'fields': "files(id, name)",
      'q': "mimeType='application/vnd.google-apps.folder' and trashed=false and 'me' in owners"
    })
    .then((results)=> {
      const files = results.result && results.result.files ? results.result.files : []
      if (files == 0) {
        dispatch(fetchGoogleDriveFoldersCompleted([]))
      } else {
        const fileData = files.map((file)=> ({
          id: file.id,
          name: file.name,
        }))
        dispatch(fetchGoogleDriveFoldersCompleted(fileData))
      }
    },
    (error)=> {
      Promise.all([
        dispatch(fetchGoogleDriveFoldersFailed(error)),
        dispatch(emitAlertMessage('error: google-drive-folders', 'error'))
      ])
    })
  }
}

export function fetchGoogleDriveFoldersCompleted(results) {
  return {
    type: FETCH_GOOGLE_DRIVE_FOLDERS_COMPLETED,
    results,
  }
}

export function fetchGoogleDriveFoldersFailed(error) {
  return {
    type: FETCH_GOOGLE_DRIVE_FOLDERS_FAILED,
    error,
  }
}

export const FETCH_GOOGLE_DRIVE_USERINFO = "FETCH_GOOGLE_DRIVE_USERINFO"
export const FETCH_GOOGLE_DRIVE_USERINFO_REQUESTED = "FETCH_GOOGLE_DRIVE_USERINFO_REQUESTED"
export const FETCH_GOOGLE_DRIVE_USERINFO_COMPLETED = "FETCH_GOOGLE_DRIVE_USERINFO_COMPLETED"
export const FETCH_GOOGLE_DRIVE_USERINFO_FAILED = "FETCH_GOOGLE_DRIVE_USERINFO_FAILED"

export function fetchGoogleDriveUserInfoRequested() {
  return {
    type: FETCH_GOOGLE_DRIVE_USERINFO_REQUESTED
  }
}

export function fetchGoogleDriveUserInfo() {
  return function(dispatch) {
    dispatch(fetchGoogleDriveUserInfoRequested())

    // Get User info from Google Drive
    const gapi = global.gapi
    return gapi.client.drive.about.get({
      'fields': "user(emailAddress, displayName)"
    })
    .then((results)=> {
      const userInfo = results.result && results.result.user ? results.result.user : {}
      dispatch(fetchGoogleDriveUserInfoCompleted(userInfo));
    },
    (error)=> {
      Promise.all([
        dispatch(fetchGoogleDriveUserInfoFailed(error)),
        dispatch(emitAlertMessage('error: google-drive-userinfo', 'error'))
      ])
    })
  }
}

export function fetchGoogleDriveUserInfoCompleted(results) {
  return {
    type: FETCH_GOOGLE_DRIVE_USERINFO_COMPLETED,
    results,
  }
}

export function fetchGoogleDriveUserInfoFailed(error) {
  return {
    type: FETCH_GOOGLE_DRIVE_USERINFO_FAILED,
    error,
  }
}

export const FETCH_REFRESH_TOKEN = "FETCH_REFRESH_TOKEN"
export const FETCH_REFRESH_TOKEN_REQUESTED = "FETCH_REFRESH_TOKEN_REQUESTED"
export const FETCH_REFRESH_TOKEN_COMPLETED = "FETCH_REFRESH_TOKEN_COMPLETED"
export const FETCH_REFRESH_TOKEN_FAILED = "FETCH_REFRESH_TOKEN_FAILED"

export function fetchRefreshTokenRequested() {
  return {
    type: FETCH_REFRESH_TOKEN_REQUESTED
  }
}

export function fetchRefreshToken() {
  return function(dispatch) {
    const auth_code = localStorage.getItem("Google_Auth_Code")
    localStorage.removeItem("Google_Auth_Code")
    dispatch(fetchRefreshTokenRequested())

    // Get refresh token from authorization code.
    const data = {
      code: auth_code,
      client_id: config.integrationKeys.google.clientId,
      client_secret: config.integrationKeys.google.clientSecret,
      redirect_uri: "postmessage",
      grant_type: 'authorization_code'
    };

    fetch('https://oauth2.googleapis.com/token', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: new URLSearchParams(data).toString()
    })
    .then(response => response.json())
    .then(results => {
      dispatch(fetchRefreshTokenCompleted(results));
      dispatch(emitAlertMessage('refresh tokenが正常に取得されました。', 'success'))
    })
    .catch(error => {
      dispatch(fetchRefreshTokenFailed(error)),
      dispatch(emitAlertMessage('error:google-refresh-token', 'error'))
    });
  }
}

export function fetchRefreshTokenCompleted(results) {
  return {
    type: FETCH_REFRESH_TOKEN_COMPLETED,
    results,
  }
}

export function fetchRefreshTokenFailed(error) {
  return {
    type: FETCH_REFRESH_TOKEN_FAILED,
    error,
  }
}

export const UPLOAD_GOOGLE_DRIVE_FILE = "UPLOAD_GOOGLE_DRIVE_FILE"
export const UPLOAD_GOOGLE_DRIVE_FILE_REQUESTED = "UPLOAD_GOOGLE_DRIVE_FILE_REQUESTED"
export const UPLOAD_GOOGLE_DRIVE_FILE_COMPLETED = "UPLOAD_GOOGLE_DRIVE_FILE_COMPLETED"
export const UPLOAD_GOOGLE_DRIVE_FILE_FAILED = "UPLOAD_GOOGLE_DRIVE_FILE_FAILED"

export function uploadGoogleDriveFileRequested() {
  return {
    type: UPLOAD_GOOGLE_DRIVE_FILE_REQUESTED
  }
}

export function uploadGoogleDriveFile(folder_id, file_name, file_url) {
  return function(dispatch) {
    const token = JSON.parse(localStorage.getItem("Google_API_Token"))
		const accessToken = token.access_token

    dispatch(uploadGoogleDriveFileRequested())

    // Get the file content from file URL
    fetch(file_url)
      .then(response => response.blob())
      .then(blob => {
        // Create the file metadata
        const formData = new FormData()
        formData.append('metadata', new Blob([JSON.stringify({
          'name': file_name,
          'mimeType': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'parents': [folder_id],
        })], { type: 'application/json' }))
        formData.append('file', blob)

        // Send the request for uploading file to Google Drive
        fetch('https://www.googleapis.com/upload/drive/v3/files?uploadType=multipart&fields=id', {
          method: 'POST',
          headers: new Headers({ 'Authorization': 'Bearer ' + accessToken }),
          body: formData
        })
        .then(response => response.json())
        .then(data => {
          dispatch(uploadGoogleDriveFileCompleted())
          dispatch(emitAlertMessage(`「${file_name}」ファイルがGoogleドライブフォルダにアップロードされました。`, 'success'))
        })
        .catch((error) => {
          dispatch(uploadGoogleDriveFileFailed(error))
          dispatch(emitAlertMessage('error: upload-google-drive-file', 'error'))
        });
    });
  }
}

export function uploadGoogleDriveFileCompleted(results) {
  return {
    type: UPLOAD_GOOGLE_DRIVE_FILE_COMPLETED,
    results,
  }
}

export function uploadGoogleDriveFileFailed(error) {
  return {
    type: UPLOAD_GOOGLE_DRIVE_FILE_FAILED,
    error,
  }
}

export const FETCH_GOOGLE_CALENDAR_EVENTS = "FETCH_GOOGLE_CALENDAR_EVENTS"
export const FETCH_GOOGLE_CALENDAR_EVENTS_REQUESTED = "FETCH_GOOGLE_CALENDAR_EVENTS_REQUESTED"
export const FETCH_GOOGLE_CALENDAR_EVENTS_COMPLETED = "FETCH_GOOGLE_CALENDAR_EVENTS_COMPLETED"
export const FETCH_GOOGLE_CALENDAR_EVENTS_FAILED = "FETCH_GOOGLE_CALENDAR_EVENTS_FAILED"

export function fetchGoogleCalendarEventsRequested(selectDate) {
  return {
    type: FETCH_GOOGLE_CALENDAR_EVENTS_REQUESTED,
    selectDate
  }
}

export function fetchGoogleCalendarEvents(selectDate, calendar) {
  const startDate = moment(selectDate).startOf('day')
  const endDate = moment(selectDate).endOf('day')

  return function(dispatch) {
    dispatch(fetchGoogleCalendarEventsRequested(selectDate))
    const gapi = global.gapi
    if(gapi && gapi.client && gapi.client.calendar && gapi.client.calendar.events) {
      return gapi.client.calendar.events.list({
              calendarId: calendar,
              timeMin: startDate.toISOString(),
              timeMax: endDate.toISOString(),
              orderBy: 'startTime',
              singleEvents: true,
              maxResults: 1000,
          })
          .then((results)=> {
              dispatch(fetchGoogleCalendarEventsCompleted(selectDate, calendar, results.result.items.map((item)=> {
                //gapi.client.calendar.events.listで20日~25日のような予定がある場合、end.dateには26日と取得されるため1日マイナスをしてreducerに渡す
                const endItem = item.end.date && moment(new Date(item.end.date).setDate(new Date(item.end.date).getDate() - 1)).format("YYYY-MM-DD")
                
                return {
                  event_id: item.id,
                  title: item.summary,
                  date: item.start.date || item.start.dateTime.slice(0, 10),
                  endDate: endItem ? endItem : null,
                  startTime: item.start.date ? null : item.start.dateTime,
                  endTime: item.start.date ? null : item.end.dateTime,
                  description: item.description
                }
              })))  
          },
          (error)=> {
            Promise.all([
              dispatch(fetchGoogleCalendarEventsFailed(error)),
              dispatch(emitAlertMessage('error:google-calendar-events', 'error'))
            ])
          })
    }else{
      dispatch(emitAlertMessage('error:google-calendar-events', 'error'))
    }
  }
}

export function fetchGoogleCalendarEventsCompleted(selectDate, calendar,results) {
  return {
    type: FETCH_GOOGLE_CALENDAR_EVENTS_COMPLETED,
    selectDate, calendar, results
  }
}

export function fetchGoogleCalendarEventsFailed(error) {
  return {
    type: FETCH_GOOGLE_CALENDAR_EVENTS_FAILED,
    error,
  }
}

export const FETCH_GOOGLE_CALENDAR_CALENDARS = "FETCH_GOOGLE_CALENDAR_CALENDARS"
export const FETCH_GOOGLE_CALENDAR_CALENDARS_REQUESTED = "FETCH_GOOGLE_CALENDAR_CALENDARS_REQUESTED"
export const FETCH_GOOGLE_CALENDAR_CALENDARS_COMPLETED = "FETCH_GOOGLE_CALENDAR_CALENDARS_COMPLETED"
export const FETCH_GOOGLE_CALENDAR_CALENDARS_FAILED = "FETCH_GOOGLE_CALENDAR_CALENDARS_FAILED"

export function fetchGoogleCalendarCalendarsRequested() {
  return {
    type: FETCH_GOOGLE_CALENDAR_CALENDARS_REQUESTED
  }
}

export function fetchGoogleCalendarCalendars() {
  return function(dispatch) {
    dispatch(fetchGoogleCalendarCalendarsRequested())
    const gapi = global.gapi
    if (gapi && gapi.client && gapi.client.calendar && gapi.client.calendar.calendarList) {
      return gapi.client.calendar.calendarList.list({ minAccessRole: 'owner', maxResults: 250 })
          .then((results)=> {
            if (!results.result.items || results.result.items.length == 0)
              dispatch(fetchGoogleCalendarCalendarsCompleted([]))
            else
              dispatch(fetchGoogleCalendarCalendarsCompleted(results.result.items.map((item)=> {
                return {
                  id: item.primary && 'primary' || item.id,
                  name: item.summary,
                }
              })))
          },
          (error)=> {
            Promise.all([
              dispatch(fetchGoogleCalendarCalendarsFailed(error)),
              dispatch(emitAlertMessage('error:google-calendar-list', 'error'))
            ])
          })
    } else {
      dispatch(emitAlertMessage('error:google-calendar-list', 'error'))
    }
  }
}

export function fetchGoogleCalendarCalendarsCompleted(results) {
  return {
    type: FETCH_GOOGLE_CALENDAR_CALENDARS_COMPLETED,
    results,
  }
}

export function fetchGoogleCalendarCalendarsFailed(error) {
  return {
    type: FETCH_GOOGLE_CALENDAR_CALENDARS_FAILED,
    error,
  }
}

export const CLEAR_GOOGLE_CALENDAR_EVENTS = "CLEAR_GOOGLE_CALENDAR_EVENTS"

export function clearGoogleCalendarEvents() {
  return {
    type: CLEAR_GOOGLE_CALENDAR_EVENTS
  }
}

export const CLEAR_GOOGLE_CALENDAR_CALENDARS = "CLEAR_GOOGLE_CALENDAR_CALENDARS"

export function clearGoogleCalendarCalendars() {
  return {
    type: CLEAR_GOOGLE_CALENDAR_CALENDARS
  }
}

export const CLEAR_GOOGLE_DRIVE_FOLDERS = "CLEAR_GOOGLE_DRIVE_FOLDERS"

export function clearGoogleDriveFolders() {
  return {
    type: CLEAR_GOOGLE_DRIVE_FOLDERS
  }
}


// WEBPACK FOOTER //
// ./src/actions/google-api.js